module.exports = __webpack_public_path__ + "static/media/stream_body-space-fitness_video_classes.2019fa02.svg";